import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <span>CONCLUA SUA MATRÍCULA</span>
          <span>AGORA!</span>
        </div>
      </div>
    </header>
  );
};

export default Header;

